const ThemeController = require('../Assets/ThemeController');

const ThemeColors = cc.Enum({
    COLOR_MAIN: 1,
    COLOR_LABEL: 2,
    COLOR_BG: 3
});
cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Node,
        passiveColor: {
            type: ThemeColors,
            default: ThemeColors.COLOR_BG
        },
        activeColor: {
            type: ThemeColors,
            default: ThemeColors.COLOR_MAIN
        },
        mouseUpActiveNodes: [cc.Node],
        mouseDownActiveNodes: [cc.Node]
    },

    onLoad () {
        this.button = this.node.getComponent(cc.Button);

        this.node.on(cc.Node.EventType.MOUSE_ENTER, this._onMouseDown.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_MOVE, this._onMouseDown.bind(this), this);
        this.node.on(cc.Node.EventType.MOUSE_LEAVE, this._onMouseUp.bind(this), this);
        this.addNestedChildListeners(this.node);

        // this.node.on(cc.Node.EventType.MOUSE_UP, this._onMouseUp.bind(this), this);

        if (!this.target) {
            if (this.button && this.button.target) {
                this.target = this.button.target;
            } else {
                this.target = this.node;
            }
        }
        this.origin = { color: ThemeController.getColor(this.passiveColor) };
        this.isMouseDown = false;

        this.hoverColor = ThemeController.getColor(this.activeColor);
    },

    addNestedChildListeners (node) {
        node.children.forEach((child) => {
            if (child.getComponent(cc.Button)) {
                child.on(cc.Node.EventType.MOUSE_LEAVE, this._onMouseUp.bind(this), this);
            }
            this.addNestedChildListeners(child);
        });
    },

    onDisable () {
        if (this.origin) {
            this._onMouseUp();
        }
    },

    _onMouseDown () {
        if (this.button && !this.button.interactable) {
            return;
        }

        if (!this.isMouseDown) {
            this._applyColor(this.target, this.hoverColor);
            this.mouseDownActiveNodes.forEach(item => item.active = true);
            this.mouseUpActiveNodes.forEach(item => item.active = false);
        }

        this.isMouseDown = true;
    },

    _applyColor (target, color) {
        if (!target) {
            return;
        }
        target.color = color;
        target.opacity = color.a;
    },

    _onMouseUp () {
        this._applyColor(this.target, this.origin.color);

        this.mouseDownActiveNodes.forEach(item => item.active = false);
        this.mouseUpActiveNodes.forEach(item => item.active = true);

        this.isMouseDown = false;
    }
});
